import { ItemsViewModeEnum } from '@/enums'

export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE'
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const PASSWORD_REGEX = /[A-Z]/
export const PRODUCTS_LIST_VIEW_MODE_COOKIE = 'products-list-view-mode'
export const PRODUCTS_LIST_VIEW_DEFAULT_MODE = ItemsViewModeEnum.GRID
export const PAGINATION_SIZE_OPTIONS = [10, 20, 30, 40, 50]
export const PAGINATION_DEFAULT_SIZE = 20
